import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { postData } from "./common/utils";

function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  let history = useHistory();

  function registerSubmit(e) {
    e.preventDefault();
    //Validate email
    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (name !== "") {
      if (re.test(email)) {
        if (
          email.indexOf(
            "@i2econsulting.com",
            email.length - "@i2econsulting.com".length
          ) !== -1
        ) {
          if (password !== "") {
            postData(process.env.REACT_APP_API_URL + "api/user/register", {
              username: name,
              email: email,
              password: password,
            }).then((data) => {
              if (data.issuccessful == true) {
                history.push("/login");
              } else {
                setMessage(data.message);
              }
            });
          } else {
            setMessage("Please enter password");
          }
        } else {
          //Non i2e email
          setMessage("Only i2econsulting.com emails allowed");
        }
      } else {
        //Invalid Email
        setMessage("Invalid email");
      }
    } else {
      setMessage("Please enter name");
    }
  }

  return (
    <div className="container">
      <div
        className="row justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="col-md-4">
          <div className="card">
            <div className="card-header">
              <h5 style={{ marginBottom: "0" }}>Register</h5>
            </div>
            <div className="card-body">
              <form onSubmit={(e) => registerSubmit(e)}>
                <div className="form-group">
                  <label htmlFor="txtName">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="txtName"
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="txtEmail">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="txtEmail"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="txtPassword">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="txtPassword"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <div
                    className="alert alert-danger"
                    role="alert"
                    style={
                      message == "" ? { display: "none" } : { display: "block" }
                    }
                  >
                    {message}
                  </div>
                </div>
                <button type="submit" className="btn btn-primary mb-3">
                  Submit
                </button>
                <div>
                  <Link to="/login">Login</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
